//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import confirmedActionButton from './confirmed-action-button.vue';
import selectionActionsMenu from './selection-actions-menu.vue';
import {
  archiveItems,
  unarchiveItems,
  bulkDelete,
} from '../db-utils.js';
import {
  upFromTaskView,
  isSubtask,
  fromMatchingDb,
} from '../utils.js';
import {
  removePlannedFor,
  bulkNestAtEnd,
  bulkRescheduleAtEnd,
  bulkStatusAtEnd,
  bulkCategoryAtEnd,
} from '../ordered-relation';
import {exportToCalendar} from '../gcalendar-utils.js'
import SelectedDateMenu from './selected-date-menu.vue';

const narrowThreshold = 350;
const wideThreshold = 830;

export default {
  data() {
    return {
      listMenu: false,
      dateMenu: false,
      categoryMenu: false,
      statusMenu: false,
      wideDisplay: window.innerWidth > wideThreshold,
      narrowDisplay: window.innerWidth < narrowThreshold,
      isMobile: (('ontouchstart' in window) ||
                  (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  components: {
    confirmedActionButton,
    selectionActionsMenu,
    SelectedDateMenu,
  },
  computed: {
    allIds() {
      if (!this.$taskCardsController ||
          !this.$taskCardsController.selectedTasksIds) {
        return [];
      }
      return Object.keys(this.$taskCardsController.selectedTasksIds);
    },
    selectedTasks() {
      return this.$taskCardsController.selectedTasks();
    },
    inTaskView() {
      return 'taskId' in this.$route.params;
    },
    selectedAreAllArchived() {
      for (const task of this.selectedTasks) {
        if (!task.archivedTimestampMs) {
          return false
        }
      }
      return true;
    },
    selectedCouches() {
      const couches = this.selectedTasks.map(item => item.couch)
      return [...new Set(couches)]
    },
    selectedAreInOneTeam() {
      return this.selectedCouches.length === 1;
    },
    statuses() {
      return this.$settings && this.$settings.statuses === true;
    },
    categories() {
      return this.$settings && this.$settings.categories === true;
    },
  },
  methods: {
    fromMatchingDb,
    exportSelected() {
      for (const task of this.selectedTasks) {
        if (task.plannedFor && task.plannedFor.parentClass === 'day') {
          exportToCalendar(task);
        }
      }
      this.$root.$emit('snackbar', {msg: "Items exported to Google Calendar"});
    },
    goUp() {
      upFromTaskView(this);
      this.$taskCardsController.leaveSpecialState()
    },
    updateIfaceWidth() {
      this.wideDisplay = window.innerWidth > wideThreshold
      this.narrowDisplay = window.innerWidth < narrowThreshold
    },
    attachSelected() {
      this.$taskCardsController.startAttachingSelection();
    },
    moveSelected(listID) {
      bulkNestAtEnd({
        reactiveCache: this.$reactiveCache,
        tasks: this.selectedTasks,
        newPPtr: {parentClass: 'list', parentKey: listID},
      })
    },
    changeStatus(listID) {
      bulkStatusAtEnd({
        reactiveCache: this.$reactiveCache,
        tasks: this.selectedTasks,
        newPPtr: {parentClass: 'list', parentKey: listID},
      })
    },
    changeCategory(listID) {
      bulkCategoryAtEnd({
        reactiveCache: this.$reactiveCache,
        tasks: this.selectedTasks,
        newPPtr: {parentClass: 'list', parentKey: listID},
      })
    },
    archiveSelected() {
      archiveItems(this.selectedTasks, this);
      this.$taskCardsController.leaveSpecialState();
    },
    unarchiveSelected() {
      unarchiveItems(this.selectedTasks)
      this.$taskCardsController.leaveSpecialState();
    },
    deleteSelected() {
      bulkDelete(this.selectedTasks)
      this.$taskCardsController.leaveSpecialState();
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateIfaceWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIfaceWidth);
  },
};
